<template>
  <v-container fluid>
    <v-layout justify-center wrap pt-3>
      <v-flex md12 style="text-align: right">
      </v-flex>
      <v-flex md12>
        <material-card color="orange" title="My Requested Masterpayers">
          <v-layout
            row
            wrap
            align-center>
            <v-flex md4>
              <v-text-field
                v-model="search"
                label="Search"
                solo
                outlined
                append-icon="search"
              />
            </v-flex>
            <v-flex class="masterpayer-status-filter" align-self-center>
              <div style="text-align: right">
                <v-checkbox
                  v-model="masterpayerRequestFilter"
                  value="New"
                  color="orange"
                  label="New"
                  hide-details
                  class="mt-0 ml-1 masterpayer-status-filter-checkbox"
                />
                <v-checkbox
                  v-model="masterpayerRequestFilter"
                  value="In Progress"
                  color="orange"
                  label="In Progress"
                  hide-details
                  class="mt-0 ml-1 masterpayer-status-filter-checkbox"
                />
                <v-checkbox
                  v-model="masterpayerRequestFilter"
                  value="Completed"
                  color="orange"
                  label="Completed"
                  hide-details
                  class="mt-0 ml-1 masterpayer-status-filter-checkbox"
                />
              </div>
            </v-flex>
          </v-layout>
          <!-- <v-layout justify-center wrap>
            <v-flex xs12 sm3 md3 offset-md9>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
              />
            </v-flex>
          </v-layout> -->
          <v-progress-linear
            v-if="masterpayerListLoading"
            color="orange"
            indeterminate/>
          <v-data-table
            :headers="masterpayerRequestHeaders"
            :items="filteredAccounts"
            :search="search"
            :pagination.sync="pagination"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text-md-left text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:items="props">
              <td>
                <router-link
                  v-if="$can('manage', 'onboarding')"
                  :to="'/masterpayer-request/view/' + props.item.Masterpayer_Request_Id"
                  class="view-link"
                  title="View" >
                  <v-icon
                    small
                    class=""
                    color="primary"
                    flat>visibility</v-icon>
                </router-link>
                <!-- <v-icon
                  small
                  class=""
                  color="primary"
                  flat
                  @click="deleteItem(props.item)">delete</v-icon> -->
                <!-- <v-icon
                  small
                  title="Changelogs"
                  class=""
                  color="primary"
                  flat
                  @click="onShowLogs(props.item)">history</v-icon> -->
              </td>
              <td>{{ props.item.Status }}</td>
              <td>{{ props.item.Dedicated_Master_Account }}</td>
              <td>{{ props.item.Client_Name }}</td>
              <td>{{ props.item.Client_SFDC_ID }}</td>
              <td>{{ props.item.Service_Line }}</td>
              <td>{{ props.item.Business_Unit }}</td>
              <td>{{ props.item.Saas_Model }}</td>
              <td>{{ props.item.Account_Model }}</td>
              <td>{{ props.item.Business_Justification }}</td>
              <td>{{ props.item.SPP_Contract_Type }}</td>
              <td>{{ props.item.AWS_Support_Type }}</td>
              <td>{{ props.item.Linked_Accounts_Type }}</td>
              <td>{{ props.item.Contract_Signature_Date }}</td>
              <td>{{ props.item.Opportunity_Id }}</td>
              <td>{{ props.item.Edp_Contract }}</td>
              <td>{{ props.item.Control_Tower_Required }}</td>
              <td>{{ JSON.parse(props.item.Control_Tower_Regions).join() }}</td>
              <td>{{ props.item.Control_Tower_Guard_Rail }}</td>
              <td>{{ props.item.Control_Tower_Cloud_Trail }}</td>
              <td>{{ props.item.Created_At }}</td>
              <td>{{ props.item.Updated_At }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <!-- <v-dialog
      v-model="linkedAccountForm.show"
      large
      persistent
      scrollable
      max-width="1000px">
      <v-card>
        <v-card-title>Delete MasterPayer</v-card-title>
        <v-card-text id="linked-account-form-content">
          <v-container>
            <p>Before you can DELETE this Master Payer, the following Acct_ID(s) that are associated with (this master payer) has to be disassociated first.</p>
            <v-data-table
              ref="masterPayerLinkedAccounts"
              :headers="linkedAccountForm.accountHeaders"
              :items="linkedAccountForm.accounts"
              :pagination.sync="mPagination"
              class="accounts-table"
              fixed-header
              item-key="Acct_name"
            >
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr :active="props.selected">
                  <td>
                    <a
                      href="#"
                      @click="onEditAccount(props.item)">{{ props.item.Acct_ID }}</a>
                  </td>
                  <td title="Account Name">{{ props.item.Acct_name }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions style="text-align: right">
          <v-spacer/>
          <v-btn @click.stop="linkedAccountForm.show = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    search: '',
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    },
    mPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    },
    masterpayerRequestFilter: ['New', 'In Progress']
  }),
  computed: {
    ...mapState('user/requestMasterpayer', ['masterpayerRequestHeaders','masterpayerRequest', 'masterpayerListLoading']),
    filteredAccounts () {
      if (this.masterpayerRequestFilter.length) {
        let filteredData = [];
        if (this.masterpayerRequestFilter.includes('New')) {
          let newData = this.masterpayerRequest.filter(account => account.Status === 'New')
          filteredData = [...filteredData, ...newData]
        }
        if (this.masterpayerRequestFilter.includes('In Progress')) {
          let inProgress = this.masterpayerRequest.filter(account => account.Status === 'In Progress')
          filteredData = [...filteredData, ...inProgress]
        }
        if (this.masterpayerRequestFilter.includes('Completed')) {
          let completedData = this.masterpayerRequest.filter(account => account.Status === 'Completed')
          filteredData = [...filteredData, ...completedData]
        }
        return filteredData;
      } else {
        return this.masterpayerRequest
      }
    }
  },
  mounted () {
     // this.$store.commit('admin/masterpayerOnboarding/clearMasterpayerRequest')
   // this.$store.dispatch('admin/masterpayerOnboarding/getAllMasterpayerRequest')
    this.$store.commit('user/requestMasterpayer/clearMasterpayerRequest')
    this.$store.dispatch('user/requestMasterpayer/getAllMyMasterpayerRequest')
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

.masterpayer-status-filter-checkbox {
    display: inline-block;
    flex: none;
  }

</style>
